/**
 * Markdown → safe HTML for rich_text / terms blocks (body_md). Parsed with
 * `marked` and sanitised with DOMPurify before it ever reaches
 * dangerouslySetInnerHTML.
 */

import { marked } from "marked";
import DOMPurify from "dompurify";

marked.setOptions({ gfm: true, breaks: true });

/** Returns sanitised HTML safe to inject. Empty string for empty/invalid input. */
export function renderMarkdown(md: string | undefined | null): string {
  if (!md) return "";
  const raw = marked.parse(md, { async: false }) as string;
  return DOMPurify.sanitize(raw, { USE_PROFILES: { html: true } });
}
